import { render, staticRenderFns } from "./SearchOrganisation.vue?vue&type=template&id=5491eedc&scoped=true"
import script from "./SearchOrganisation.vue?vue&type=script&lang=js"
export * from "./SearchOrganisation.vue?vue&type=script&lang=js"
import style0 from "./SearchOrganisation.vue?vue&type=style&index=0&id=5491eedc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5491eedc",
  null
  
)

export default component.exports